/**
 * Copyright 2016 xdot GmbH
 * Author: Carsten Bühler
 * Date: 07.06.2016
 *
 */
'use strict';


import React from 'external/react';
import PropTypes from 'external/prop-types';
import { ListGroupItem } from 'external/react-bootstrap';

class MapLinkListItem extends React.Component {

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    onClick(e) {
        this.props.onClick(this.props.item, e);
    }

    render() {
        const { item, active } = this.props;

        return (
            <ListGroupItem className={'link-list-item ' + (active ? 'active' : '')}
                disabled={!!item.active}
                onClick={this.onClick}>
                <span
                    className="link-title">{item.title + (item.parentOrganizationName ? ' (' + item.parentOrganizationName + ')' : '')}</span>
            </ListGroupItem>
        );
    }
}

MapLinkListItem.propTypes = {
    ...ListGroupItem.propTypes,
    item: PropTypes.object.isRequired,
    onClick: PropTypes.func
};

export default MapLinkListItem;



// WEBPACK FOOTER //
// ./js/map/FliwasOrganizationMapLinkListItem.jsx